export default function SendLinkIcon() {
    return (
        <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.4"
                d="M10.75 11L2.25 11"
                stroke="#292D32"
                strokeWidth="0.5625"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 1.75L3 8.75"
                stroke="#292D32"
                strokeWidth="0.5625"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 6.885L10 1.75L4.865 1.75"
                stroke="#292D32"
                strokeWidth="0.5625"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
